module.exports = __webpack_public_path__ + "img/avatar_pirate.c1df4314.svg";